import { Euler, Object3D, Scene, Vector3 } from "three";
import { Engine } from "../../engine/Engine";
import { AbstractWall } from "../../shape/walls/AbstractWall";
import { CSS2DObjectElement } from "./CSS2DObjectElement";
import { CSS3DObjectElement } from "./CSS3DObjectElement";

export class CSS3DObjectWallMenu extends Object3D {
  private _objectElement: CSS3DObjectElement;
  private _cssMenuElement: HTMLDivElement;
  private _wall: AbstractWall;

  constructor(
    wall: AbstractWall,
    options: {
      minScale?: number;
      maxScale?: number;
      offset?: Vector3;
      rotation?: Euler;
    }
  ) {
    super();
    this._wall = wall;
    this._cssMenuElement = this._createWallElement();
    this._objectElement = new CSS3DObjectElement(
      this._cssMenuElement,
      "wall-menu",
      options
    );

    this.addEventListener("added", () => {
      this.add(this._objectElement);
    });

    this.addEventListener("removed", () => {
      this.remove(this._objectElement);
    });
  }

  private onClick = (e: Event) => {
    Engine.activeEngine.dispatchCustomEvent("select-wall", {
      detail: { wall: this._wall.root, ref: this._wall, event: e },
    });
  };

  private _createWallElement = () => {
    const wallElement = document.createElement("div");
    const root = document.createElement("div");
    root?.appendChild(wallElement);
    wallElement.style.backgroundColor = "rgb(255, 255, 255)";
    wallElement.style.borderRadius = "100%";
    wallElement.style.width = "30px";
    wallElement.style.height = "30px";
    wallElement.style.fontSize = "10px";
    wallElement.style.fontWeight = "300";
    wallElement.style.fontFamily = '"DM Sans", sans-serif';
    wallElement.style.whiteSpace = "nowrap";

    wallElement.style.pointerEvents = "auto";
    wallElement.style.borderColor = "rgb(47 119 86 / 35%)";
    wallElement.style.minWidth = "15px";
    wallElement.style.minHeight = "16px";

    wallElement.style.borderWidth = "1px";
    wallElement.style.borderColor = "rgba(47, 119, 86, .35)";

    wallElement.style.display = "flex";
    wallElement.style.justifyContent = "space-around";
    wallElement.style.alignItems = "center";
    wallElement.style.borderStyle = "solid";
    wallElement.innerHTML = `<div > <svg width="16px" height="16px"  data-v-a281fab8-s="">
    <use xlink:href="#icon-edit-wall"></use>
  </svg></div>`;

    wallElement.addEventListener("click", this.onClick.bind(this));
    return root;
  };

  update() {}

  removeFromParent(): this {
    super.removeFromParent();
    this._objectElement.removeFromParent();
    return this;
  }

  dispose(scene?: Scene) {
    this._objectElement.removeFromParent();
    this._cssMenuElement.remove();
  }
}
